import { searchInfo, searchCharacters } from "./API";
import { resolvePromise } from "./resolvePromise.js";
import { quizData } from "./quizConst"; 
import { shuffleQuestions } from "./utilities.js";

const model = {
    userID: null,
    currentQuizID: null,
    quizHistory: [],
    searchText: "",
    searchFilter: {},
    changeFlag:true,
    page: 'Main',
    searchResultsPromiseState: {},
    detailInfo: {},
    ready: true,

    questionData: shuffleQuestions(quizData),
    currentQuestion: 0,
    score:0,
    clickedOption:0,
    showQuizSummary: false,

    setUserID(id){
        this.userID = id;
        if(!id) this.quizHistory=[];
    },

    setCurrentQuizID(quizID){
        this.currentQuizID = quizID;
    },

    setSearchText(name){
        this.searchText = name
    },

    deleteSearchText(){
        this.searchText = ''
    },

    setSearchFilter(type, option){
        this.searchFilter[type] = option
        this.changeFlag = !this.changeFlag
    },

    deleteSearchFilter(type){
        delete this.searchFilter[type]
        this.changeFlag = !this.changeFlag

    },

    clearSearchFilter(){
        this.searchFilter={}
        this.searchText=''
    },

    setPage(page){
        this.page = page
    },

    async doSearch(){
        let prms
        if(this.page == 'Characters') 
            prms = searchCharacters(this.searchText, this.searchFilter)//searchCharacters(this.searchParams)
        else
            prms = searchInfo(this.page, this.searchText, this.searchFilter)

        this.searchResultsPromiseState = await resolvePromise(prms, this.searchResultsPromiseState)
            
    },

    setDetail(id){
        this.detailInfo = this.searchResultsPromiseState.data.filter(d => d.id == id)[0]
    },

    updateQuizHistory() {
        this.changeFlag=!this.changeFlag
        const quizDateTime = new Date().toISOString();
        if(!this.quizHistory) this.setQuizHistory([{ currentQuizID: this.currentQuizID, quizDateTime, score: this.score }])
        else this.quizHistory.push({ currentQuizID: this.currentQuizID, quizDateTime, score: this.score });
    },

    setQuizHistory(history){
        this.quizHistory = history;
    },

    setCurrentQuestion(currentQuestion) {
        this.currentQuestion = currentQuestion;
    },

    setShowQuizSummary(showQuizSummary) {
        this.showQuizSummary = showQuizSummary;
    },

    setScore(score) {
        this.score = score;
    },

    setClickedOption(clickedOption) {
        this.clickedOption = clickedOption;
    },
}

export {model};